import {
  NaturalWrittenSubtractionTwoByTwoTask,
  NaturalWrittenSubtractionThreeByTwoTask,
  NaturalWrittenSubtractionThreeByThreeTask,
  NaturalWrittenSubtractionFourByFourTask,
  NaturalWrittenSubtractionLargeMixedTask,
} from "./podtemat2_odejmowanie_pisemne_types/NaturalWrittenSubtractionTask";

export const registry = {
  NaturalWrittenSubtractionTwoByTwoTask,
  NaturalWrittenSubtractionThreeByTwoTask,
  NaturalWrittenSubtractionThreeByThreeTask,
  NaturalWrittenSubtractionFourByFourTask,
  NaturalWrittenSubtractionLargeMixedTask,
};

export function generateTasks() {
  return [
    NaturalWrittenSubtractionTwoByTwoTask.generateTask(),
    NaturalWrittenSubtractionThreeByTwoTask.generateTask(),
    NaturalWrittenSubtractionThreeByThreeTask.generateTask(),
    NaturalWrittenSubtractionFourByFourTask.generateTask(),
    NaturalWrittenSubtractionLargeMixedTask.generateTask(),
  ];
}

export function renderTask(task) {
  return registry[task.type]?.renderTask(task) || null;
}

export function renderInput(task, userAnswer, onChange, disabled) {
  return registry[task.type]?.renderInput(task, userAnswer, onChange, disabled) || null;
}

export function checkAnswer(task, userAnswer) {
  return registry[task.type]?.checkAnswer(task, userAnswer) || false;
}

export function renderAnswer(task) {
  return registry[task.type]?.renderAnswer(task) || null;
}

export function renderExplanation(task) {
  return registry[task.type]?.renderExplanation(task) || null;
}

export function renderUserAnswer(task, userAnswer) {
  return registry[task.type]?.renderUserAnswer(userAnswer) || null;
}
